import { inject, Injectable } from '@angular/core';

import { UserGetDTO } from '../users/users.model';
import { map, Observable } from 'rxjs';

import { ClientDetailDTO, ClientGetDTO } from './client.model';
import { environment } from '../../../environments/environment';
import { ApiResponseModel } from '../../core/api-response.model';
import { RoleService, RoleType } from '../../core/services/role.service';
import { BaseCrudService } from '../../services/apps/generic/base.service';

export interface AppUser {
  id: string;
  fullName: string;
  email: string;
  role: string;
}

@Injectable({ providedIn: 'root' })
export class ClientService extends BaseCrudService<
  ApiResponseModel<ClientGetDTO>,
  any,
  any,
  any
> {
  roles = inject(RoleService);
  constructor() {
    super('/api/users');
  }

  override get(
    id?: any,
    params?: Record<string, any>
  ): Observable<ApiResponseModel<ClientGetDTO>> {
    const qp = {
      ...params,
      roleId: this.roles.getRoleByName(RoleType.Client)?.id,
    };
    return super.get(id, qp).pipe(
      map((res) => {
        return {
          ...res,
          data: res.data.map((item) => ({
            ...item,
            companyName: item.client.companyName,
            customPrefix: item.client.customPrefix,
          })),
        } as ApiResponseModel<ClientGetDTO>;
      })
    );
  }

  getClientById(id: string) {
    return this.http.get<ClientDetailDTO>(
      `${environment.baseApiUrl}/api/users/${id}`
    );
  }
  updateClient(client: any) {
    return this.http.put(`${environment.baseApiUrl}/api/users`, client);
  }
}
